export const ACCEPTED_PRIVACY_POLICY_KEY = "ACCEPTED_PRIVACY_POLICY_KEY";
export const EMAIL_KEY = "EMAIL_KEY";
export const TOKEN_KEY = "TOKEN_KEY";

export const HAS_AN_AVAILABLE_VOUCHER = "HAS_AN_AVAILABLE_VOUCHER";
export const SUBGRAPH_URL = "SUBGRAPH_URL";
export const CHAIN_ID = "CHAIN_ID";

export const RECEIVED_TICKET_AT_KEY = "RECEIVED_TICKET_AT_KEY";
export const RECEIVED_TICKET_FROM_INTEGRATION =
  "RECEIVED_TICKET_FROM_INTEGRATION";
